import { registerContinuously } from '@/helpers/Widget'
import EntryWidget from '@/modules/EntryWidget/components/EntryWidget'

registerContinuously(EntryWidget, '.sanitasOvpEntry', props => {

  return props
})
